export { default } from "./not-found-view.js";
